import { DialogActions as MDialogActions, Typography } from '@mui/material';
import styled from 'styled-components';
export const Header = styled.div `
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TitleWrapper = styled.div `
  display: flex;

  && svg {
    padding-left: 10px;
  }
`;
export const HeaderTitle = styled(Typography) `
  ${({ headerwidth, closebuttonwidth }) => headerwidth !== '100%' && closebuttonwidth !== undefined
    ? `width: ${parseFloat(headerwidth) - closebuttonwidth}px;`
    : ``}
  ${({ wraptitle }) => wraptitle ? `white-space: normal;` : `white-space: nowrap;`}
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const DialogActions = styled(MDialogActions) `
  margin: 0 0.5rem 0.5rem;
  && {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
  }
  && :not(:first-child) {
    margin-right: 0.5rem;
  }
  && :last-child {
    ${({ hasleftdialogactions }) => hasleftdialogactions === 'true' && 'margin-left: 0'}
  }
`;
export const LeftDialogActionsWrapper = styled.div `
  flex: auto;
`;
